import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface SubMenuItemProps {
  Icon: React.ElementType
  label: string
  iconColor?: string
  linkPath: string
}

const SubMenuItem: React.FC<SubMenuItemProps> = ({ Icon, label, iconColor = '#828282', linkPath }) => {
  const location = useLocation()
  const { pathname, search } = location

  // Split the linkPath into base path and query string
  const linkPathParts = linkPath.split('?')
  const basePath = linkPathParts[0]
  const linkQueryString = linkPathParts[1] || ''

  // Parse query parameters
  const linkParams = new URLSearchParams(linkQueryString)
  const currentParams = new URLSearchParams(search)

  // Check if all query parameters in the link match the current URL
  const queryParamsMatch = Array.from(linkParams.entries()).every(([key, value]) => currentParams.get(key) === value)

  // Item is active if pathname matches and all query parameters match
  const isActive = pathname === basePath && queryParamsMatch

  return (
    <Link to={linkPath} className="flex items-center justify-between w-full px-16 py-5">
      <div
        className={`flex items-center space-x-15 cursor-pointer ${
          isActive ? 'text-topaz' : 'text-menuLink hover:text-topaz'
        }`}
      >
        <Icon color={iconColor} className="w-16 h-16" />
        <span className="text-xs leading-5 font-semibold">{label}</span>
      </div>
    </Link>
  )
}

export default SubMenuItem
